const adminStatistics = {
  actions: {
    refresh: '刷新',
    retry: '重试',
  },
  charts: {
    appRanking: '应用排行',
    empty: '当前时间范围暂无图表数据',
    sessions: '会话数',
    uniqueUsers: '用户数',
    usageTrend: '使用趋势',
    viewAll: '查看全部',
  },
  conversationLogs: {
    columns: {
      label: '选择 Dify 对话日志列',
      trigger: '列设置',
    },
    description: '查看当前 Dify 实例的消息与 Workflow 运行记录，并导出当前可见字段。',
    dataSource: {
      notConfigured: 'Dify 数据源未配置，请在服务端 .env 中填写 DIFY_DB_* 并重启服务。',
      unavailable: '无法连接 Dify 数据源，请检查网络连通性与数据库账号密码。',
    },
    empty: '当前筛选条件下没有 Dify 对话日志',
    error: {
      description: '暂时无法读取 Dify 对话日志，请稍后重试。',
      title: 'Dify 对话日志加载失败',
    },
    export: {
      csv: '导出 CSV',
      errorEmpty: '当前筛选条件下没有数据可导出。',
      errorGeneric: '导出失败，请稍后重试。',
      errorLimit: '导出数据超过 5 万行上限，请缩小日期范围或增加筛选条件。',
      success: '已导出 {{filename}}',
      xlsx: '导出 XLSX',
    },
    fields: {
      answer: '回答',
      answer_tokens: '回答 token',
      app_id: '应用 ID',
      app_name: '应用名称',
      app_mode: '应用类型',
      conversation_id: '对话 ID',
      conversation_name: '会话标题',
      created_at: '创建时间',
      currency: '币种',
      end_user_id: '终端用户 ID',
      end_user_session_id: '终端会话 ID',
      error: '错误信息',
      id: '记录 ID',
      inputs: '输入变量',
      message_tokens: '问题 token',
      model_id: '模型 ID',
      model_provider: '模型供应商',
      outputs: '输出变量',
      query: '用户问题',
      record_key: '记录键',
      record_type: '记录类型',
      status: '状态',
      tenant_id: 'Workspace ID',
      tenant_name: 'Workspace',
      total_price: '总费用',
      total_tokens: '总 token',
      trigger_source: '触发来源',
      updated_at: '更新时间',
    },
    filters: {
      allApps: '全部应用',
      allRecordTypes: '全部记录类型',
      allWorkspaces: '全部 Workspace',
      app: '应用',
      endDate: '结束日期',
      keyword: '关键词',
      keywordPlaceholder: '搜索标题、问题、ID、应用或 Workspace...',
      recordType: '记录类型',
      startDate: '开始日期',
      workspace: 'Workspace',
    },
    fullText: {
      title: '完整内容 / {{field}}',
    },
    recordTypes: {
      message: '消息',
      workflow_run: 'Workflow 运行',
    },
    sort: {
      toggle: '按{{field}}排序',
    },
    title: 'Dify 对话日志',
    workflowFallback: {
      default: '工作流运行',
      plugin: '插件触发',
      schedule: '定时任务触发',
      webhook: 'Webhook 触发',
    },
    workspaceLabel: 'Dify 对话日志工作区',
  },
  description: '查看应用使用规模、运行质量与应用排行。',
  details: {
    feedback: '反馈汇总',
    negative: '负向反馈',
    overview: '应用概览',
    positive: '正向反馈',
    title: '应用详情 / {{name}}',
    users: '用户明细',
  },
  empty: {
    dashboard: '当前时间范围暂无使用数据',
    ranking: '没有符合条件的应用',
    users: '当前时间范围暂无用户明细',
  },
  error: {
    dashboardDescription: '暂时无法读取使用看板，请稍后重试。',
    dashboardTitle: '使用看板加载失败',
    detailsDescription: '暂时无法读取应用详情。',
    detailsTitle: '应用详情加载失败',
    permissionDescription: '当前管理员账号没有查看使用统计的权限。',
    permissionTitle: '无权访问使用看板',
    rankingDescription: '暂时无法读取完整应用排行。',
    rankingTitle: '应用排行加载失败',
  },
  metrics: {
    avgFirstTokenLatency: '首 token 平均延迟',
    avgSessionDuration: '平均会话时长',
    completedRate: '完成率',
    providerErrorRate: '服务异常率',
    totalApps: '应用数',
    totalConversations: '对话数',
    totalDuration: '总使用时长',
    totalFeedbacks: '反馈数',
    totalSessions: '会话数',
    totalUsers: '用户数',
    userStopRate: '用户中止率',
  },
  pagination: {
    next: '下一页',
    pageSize: '每页 {{size}} 条',
    previous: '上一页',
  },
  ranking: {
    searchLabel: '搜索应用',
    searchPlaceholder: '搜索应用名称...',
    sortByLabel: '排序指标',
    sortOrderLabel: '排序方向',
    title: '全部应用排行',
  },
  sections: {},
  sort: {
    ascending: '升序',
    descending: '降序',
    sessions: '按会话数',
    users: '按用户数',
  },
  table: {
    actions: '操作',
    app: '应用',
    duration: '使用时长',
    email: '邮箱',
    feedback: '反馈',
    lastUsedAt: '最近使用',
    sessions: '会话数',
    user: '用户',
    users: '用户数',
    viewDetails: '查看详情',
  },
  timeRange: {
    custom: '自定义',
    endDate: '结束日期',
    label: '时间范围',
    presets: {
      day: '近一天',
      last90days: '近 90 天',
      month: '近 30 天',
      week: '近一周',
    },
    startDate: '开始日期',
  },
  title: '应用使用看板',
  units: {
    milliseconds: '{{value}} ms',
    seconds: '{{value}} 秒',
  },
  workspaceLabel: '应用使用看板工作区',
}

export default adminStatistics
